import { EventType } from './events';

// Helper function to normalize API responses
export const normalizeEventType = (type: string | null | undefined): EventType => {
  if (!type) return 'In-Person';
  
  // Convert Online to Virtual
  if (type.toLowerCase() === 'online') return 'Virtual';
  
  // If it's already one of our types, use it
  if (type === 'In-Person' || type === 'Virtual') return type;
  
  // Default fallback
  return 'In-Person';
};

export interface Event {
  id: number;
  remoteObjectId: string;
  name: string;
  nameFr: string;
  type: string;
  isActive: boolean;
  isMaroline: boolean;
  description: string | null;
  descriptionFr: string | null;
  startDate: string;
  endDate: string;
  location: string | object;
  status: string;
  ultimateParent: string;
  pointsToEarn: number | null;
  duration: number | null;
  eventType: string | null;
  showroom?: string;
  appointmentId?: string;
  city?: string;
  durationUnit?: string;
  isAttended?: boolean;
  appointmentType?: EventType | null;
  eventSubtype?: string;  // Added to support subtype-based form selection
}
